<template>
  <el-row type="flex" align="middle">
    <gj-select
        class="gj-select"
        v-model="value['key']"
        :placeholder="placeholder[1]"
        :width="mapSelectWidth"
        :options="options"
        @input="$emit('input', value)"
        :clearable="false"
    ></gj-select>
<!--    <gj-date-picker-->
<!--                    v-model="value['value']"-->
<!--                    :type="type"-->
<!--                    :shortcut="shortcut"-->
<!--                    :width="mapDateWidth"-->
<!--                    :clearable="dateClearable"-->
<!--                    :max-day-length="maxDayLength"-->
<!--                    :tooltip="tooltip"-->
<!--                    @input="$emit('input', value)"-->
<!--    ></gj-date-picker>-->
    <gj-date-picker-active
        v-model="value['value']"
        :type="type"
        :shortcut="shortcut"
        :width="mapDateWidth"
        :shortcuts="shortcuts"
        :clearable="false"
        :max-day-length="maxDayLength"
        :tooltip="tooltip"
        @input="$emit('input', value)"
    ></gj-date-picker-active>
  </el-row>
</template>

<script>
import GjDatePicker from "@/components/date-picker/gj-date-picker";
import GjDatePickerActive from "@/components/date-picker/gj-date-picker-active";
import GjSelect from "@/components/select/gj-select";
import {defaultVal, isMeaningful} from "@/utils/common";
import {tooltipMixin} from "@/minxins";

export default {
  name: "gj-select-date-picker-active",
  mixins: [tooltipMixin],
  components: {GjSelect},
  props: {
    value: {
      type: Object,
      required: true
    },
    placeholder: {
      type: Array,
      default: () => ['请选择', '请选择']
    },
    type: {
      type: String,
      default: 'date'
    },
    width: {
      type: Array
    },
    options: {
      type: Array,
      required: true
    },
    dateClearable: {
      type: Boolean,
      default: true,
    },
    maxDayLength: {
      type: Number,
      default: null
    },
    shortcut:{
      type: Boolean,
      default: true
    },
    shortcuts: {
      type: Array
    }
  },
  computed: {
    mapSelectWidth() {
      // 返回null，表示使用传入组件的默认宽度
      return isMeaningful(this.width) ? defaultVal(this.width[0], null) : null;
    },
    mapDateWidth() {
      // 返回null，表示使用传入组件的默认宽度
      return isMeaningful(this.width) ? defaultVal(this.width[1], null) : null;
    },
  }
}
</script>

<style lang="scss" scoped>
.gj-select /deep/ .el-input .el-input__inner {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right-color: rgba($color: #000000, $alpha: 0);
}
.gj-select /deep/ .is-focus .el-input__inner {
  border-right-color: rgba($color: #1F6EEF, $alpha: 1);
}
.gj-select /deep/ .el-input .el-input__inner {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.gj-select /deep/ .el-input:hover .el-input__inner,
.gj-select /deep/ .el-input .el-input__inner:focus {
  /* border-right-width: 1px !important; */
  border-right-color: rgba($color: #1F6EEF, $alpha: 1) !important;
}
/deep/ .el-date-editor.el-input__inner,
/deep/ .el-date-editor .el-input__inner {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
